import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./app/router";
import { SessionProvider } from "./features/auth/session";
import { I18nProvider } from "./shared/i18n";
import "./shared/ui/tokens.css";
import "./shared/ui/app.css";

// I18nProvider sits OUTSIDE SessionProvider so that the login page — which renders
// before any session exists — is translated too.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <SessionProvider>
          <AppRoutes />
        </SessionProvider>
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
);
